import React, { Suspense } from 'react';

import { Meetings as MeetingsView } from '@modules/Meetings/views/Meetings';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';


export const Meetings: React.FC = () => {

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%"/>}>
        <MeetingsView/>
      </Suspense>
    </ErrorBoundary>
  );
};
